import { useState } from 'react'
import './logoutmodal.css'
import { Button, Col, Image, Row } from 'react-bootstrap';
import { toast } from 'react-toastify';
import Toastify from 'toastify-js'
import { pushEvent, EVENTS } from '../../utils/dataLayer';
import { clearSession, logoutRedirectPath } from '../../utils/entryFlow';

function LogoutModal({ show, onClose }) {
    const userLogOut = () => {
        // Before localStorage.clear() so the event still carries user_id.
        pushEvent(EVENTS.LOGOUT);
        Toastify({
            text: 'Logout successfully',
            duration: 3000,
            newWindow: true,
            close: true,
            gravity: "bottom", // `top` or `bottom`
            position: "center", // `left`, `center` or `right`
            stopOnFocus: true, // Prevents dismissing of toast on hover
            style: {
                background: "linear-gradient(to right, #000000ff, #000000ff)",
            },
            onClick: function () { } // Callback after click
        }).showToast();
        clearSession(); // remove all (keeps the /weekly entry marker)
        localStorage.removeItem('utmData'); 
        setTimeout(() => {
            window.location.href = logoutRedirectPath();
        }, 1000);
    }
    if (!show) return null;
    return (
        <div style={{
            position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
            backgroundColor: 'rgba(0,0,0,75%)', zIndex: 9999, display: 'flex', justifyContent: 'center', alignItems: 'center'
        }}>
            <div className='modal-css'>
                <Row>
                    <Col md={12} xs={12} className='login-continue-wrapper mb-3 mt-10'>
                        <span className='heading-logout'>Are you sure you want to logout?</span>
                    </Col>
                    <Col md={12} xs={12} className='otp-sent-wrapper' onClick={onClose}>
                        <span className='custom-btn primary pointer'>Cancel</span>
                    </Col>
                    <Col md={12} xs={12} className='otp-sent-wrapper mb-10' onClick={userLogOut}>
                        <span className='custom-btn pointer'>Logout</span>
                    </Col>
                </Row>
            </div>
        </div>
    );
}
export default LogoutModal